import { render, staticRenderFns } from "./LoginV2Component.vue?vue&type=template&id=85b0f330&scoped=true&"
import script from "./LoginV2Component.vue?vue&type=script&lang=js&"
export * from "./LoginV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b0f330",
  null
  
)

export default component.exports